import { AbstractFWSiteParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWSiteParams';
import { IFWPauseAdSiteParams } from 'tag/ts/tag/interfaces/ads/pause/IFWPauseAdSiteParams';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @description Freewheel site parameters for pause ads
 */
export class FWPauseAdSiteParams extends AbstractFWSiteParams {

	/**
	 * @description Internal store for site ad parameters
	 * @type {IFWPauseAdSiteParams}
	 * @readonly
	 */
	protected readonly adParams: IFWPauseAdSiteParams;

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'FWPauseAdSiteParams',
				...argument
			}
		);

		this.adParams = this.appendFMSData( this.#createParams() ) as IFWPauseAdSiteParams;
	}

	/**
	 * @description Creates site parameters for pause ads
	 * @returns {IFWPauseAdSiteParams}
	 */
	#createParams(): IFWPauseAdSiteParams {
		const paramsVO = this?.tag?.params;
		const fmsResponse = paramsVO?.AD?.FW?.FMS;
		const gdprResponse = paramsVO?.AD?.FW?.GDPR;
		const coppa = ( !!this.isPPlus() && !this.utils?.Type?.isEmpty( this.siteSessionData?.tfcd ) ) ? this.siteSessionData?.tfcd.toString() : undefined;

		const params: IFWPauseAdSiteParams = {
			_fw_ae: paramsVO?.USER?.mvpdId,
			_fw_continuous_play: !!this.isLive() ? undefined : this.siteSessionData?.cpSession,
			_fw_coppa: coppa,
			_fw_vcid2: fmsResponse?._fw_vcid2,
			_fw_gdpr: gdprResponse?._fw_gdpr?.toString(),
			_fw_gdpr_consent: gdprResponse?._fw_gdpr_consent?.toString(),
			_fw_is_lat: this.siteSessionData?._fw_is_lat,
			_fw_us_privacy: paramsVO?.USER?.usPrivacy,
			region: this.siteSessionData?.region
		};
		this.logger?.log( 'createParams:', params );
		return params;
	}

	/**
	 * @description Returns site parameters for pause ads
	 * @returns {IFWPauseAdSiteParams}
	 */
	get adParameters(): IFWPauseAdSiteParams {
		return this.adParams;
	}
}